export const restrictionLabels = {
  RESTRICTED_ADD_PHONE_NUMBER_ACTION: "add new phone numbers",
  RESTRICTED_BIZ_INITIATED_MESSAGING: "send messages and templates to customers",
  RESTRICTED_CUSTOMER_INITIATED_MESSAGING: "reply to customer messages",
};